// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const getLearningPathways = async () => {
  return await fetch(
    "https://us-central1-zefi-cms.cloudfunctions.net/getLearningPathways/en",
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.log(error);
    });
};

export { getLearningPathways };
